// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"lazysizes":"fc5a4a71210fa808efe8","flickity":"80c75c2b4489c261a974","axios":"24c71bfc12280cf5abc5"}[chunkId] + ".js";
};